import React from 'react';
import { SectionHeader } from '../ui/SectionHeader';
import type { Workspace } from '../../types/content';
export function WorkspaceWorkflow({
  workspace
}: {
  workspace: Workspace;
}) {
  const {
    steps
  } = workspace.workflow;
  return <section className="py-20 md:py-28" data-id="element-553" data-mp="2d5m3ym2yxapm">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-554" data-mp="287as65t44q4r">
        <SectionHeader title={workspace.workflow.title} body="One concrete workflow, using sample records." data-id="element-555" data-mp="287kjbwpw93c1" />
        <ol className="relative mt-14 grid gap-8 md:grid-cols-5 md:gap-5" data-id="element-556" data-mp="1khq4xapxf6po">
          <span className="absolute left-0 right-0 top-[15px] hidden h-px bg-ink/10 md:block" aria-hidden="true" data-id="element-557" data-mp="1fjonsvc29hgu" />
          {steps.map((s, i) => <li key={s.title} className="relative flex gap-4 md:block" data-id="element-558" data-mp="1pgkpah3jl3bw" data-mpi={i}>
              <span className={`relative flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[13px] font-semibold tabular-nums ${i === steps.length - 1 ? 'bg-accent text-white shadow-glow' : 'bg-white text-ink ring-1 ring-ink/10'}`} data-id="element-559" data-mp="1pinonrql48ta">
                {i + 1}
              </span>
              <div className="md:mt-5" data-id="element-560" data-mp="1on3xeicfcylq">
                <h3 className="text-[17px] font-semibold tracking-tight" data-id="element-561" data-mp="1oq9kxt5ensfc">{s.title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-ink-soft" data-id="element-562" data-mp="1sqjqj4pacgto">{s.body}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}